/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as DoctorDataStoreActions from './doctor-data-store.actions';

import { Doctor } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'DoctorDataStore';

/* State interface */
export interface DoctorState {
  isLoading?: boolean;
  doctors?: Doctor[];
  activeDoctor?: Doctor;
}

/* Initial values */
export const initialState: DoctorState = {
  isLoading: null,
  doctors: null,
  activeDoctor: null,
};

export const reducer = createReducer(
  initialState,
  on(DoctorDataStoreActions.GetDoctors, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(DoctorDataStoreActions.GetDoctorsSuccessful, (state, action) => ({
    ...state,
    doctors: action.payload.doctors,
    isLoading: false,
  })),

  on(DoctorDataStoreActions.GetDoctorsFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(DoctorDataStoreActions.GetDoctorById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(DoctorDataStoreActions.GetDoctorByIdSuccessful, (state, action) => ({
    ...state,
    /* TODO: replace item by id from data array */
    isLoading: false,
  })),

  on(DoctorDataStoreActions.GetDoctorByIdFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(DoctorDataStoreActions.CreateDoctor, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(DoctorDataStoreActions.CreateDoctorSuccessful, (state, action) => ({
    ...state,
    doctors: [...(state.doctors ?? []), action.payload.doctor],
    isLoading: false,
  })),

  on(DoctorDataStoreActions.CreateDoctorFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(DoctorDataStoreActions.UpdateDoctor, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(DoctorDataStoreActions.UpdateDoctorSuccessful, (state, action) => ({
    ...state,
    doctors: updateEntityInArray<Doctor>(
      action.payload.id,
      action.payload.data,
      state.doctors ?? [],
    ),
    isLoading: false,
  })),

  on(DoctorDataStoreActions.UpdateDoctorFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(DoctorDataStoreActions.DeleteDoctor, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(DoctorDataStoreActions.DeleteDoctorSuccessful, (state, action) => ({
    ...state,
    doctors:
      state.doctors?.filter((item) => action.payload.id !== item.id) ?? [],
    isLoading: false,
  })),

  on(DoctorDataStoreActions.DeleteDoctorFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(DoctorDataStoreActions.ResetState, () => initialState),
);
